import { GLYPHS, Icon } from 'components/Shared/Icon';
import React from 'react';

import styles from './social-icons.module.scss';

export function SocialIcons() {
    return (
        <div className={styles.social_icons}>
            <a
                href="https://twitter.com/snazzymaps"
                target="_blank"
                rel="noreferrer noopener"
                title="Follow us on Twitter"
            >
                <Icon glyph={GLYPHS.TWITTER} />
            </a>
            <a
                href="https://www.facebook.com/SnazzyMaps"
                target="_blank"
                rel="noreferrer noopener"
                title="Like us on Facebook"
            >
                <Icon glyph={GLYPHS.FACEBOOK} />
            </a>
            <a href="mailto:support@snazzymaps.com" title="Email us at support@snazzymaps.com">
                <Icon glyph={GLYPHS.MAIL} />
            </a>
        </div>
    );
}
